export default __webpack_public_path__ + "static/media/29.e7e46f7b.jpg";